import * as React from "react";
import * as ReactDOM from "react-dom";
import * as _ from "lodash";
import {connect} from "react-redux";
import {IScreenComponentProps, screenComponent} from "../screenComponent";
import {showHowToPlay, showLeaderboard} from "../../../store/actions/screens";
import {showGameIntro, startGame} from "../../../store/actions/game";
import Button from "../../common/ui/button/Button";
import {CSSTransition, TransitionGroup} from 'react-transition-group';

interface MainMenuProps extends IScreenComponentProps
{
    showLeaderboard: () => void;
    showGameIntro: () => void;
    showHowToPlay: () => void;
}

interface State
{
    active: boolean;
}

import * as styles from './MainMenu.scss';
import Clouds from '../game/map/Clouds';

class MainMenu extends React.Component<MainMenuProps, State>
{
    constructor(public props: MainMenuProps, public state: State = { active: false })
    {
        super(props);
    }


    onMount = _.debounce(() =>
    {
        this.setState({ active: true });
    }, 10);



    /**
     * render the component
     * @returns {JSX.Element}
     */
    render() : JSX.Element
    {
        const {active:pactive} = this.props;
        const {active:sactive} = this.state;
        const active: boolean = pactive && sactive;

        // if (! active) return null;

        return <CSSTransition
            in={active}
            timeout={400}  //  4000
            classNames={{
                enter: styles.enter,
                enterActive: styles.enterActive,
                exit: styles.exit,
                exitActive: styles.exitActive,
            }}
            appear
            mountOnEnter
            unmountOnExit
            ref={this.onMount}>

            <div
                styleName={'main-menu'} >

                <div
                    styleName={'background'} />

                <Clouds />

                <div
                    styleName={'content'}>

                    <img src="./img/main-menu/logo.png" />

                </div>

                <div
                    styleName={'education-logo'}>

                    {/*<img src="./img/main-menu/edf-logo.png" />*/}

                </div>

                <div
                    styleName={'menu-buttons'}>

                    {/*<Button
                        type={'show-leaderboard'}
                        onClick={this.props.showLeaderboard}>Achievement board</Button>*/}

                    <Button
                        type={'file-download'}
                        onClick={null}>

                        <a href={'assets/supporting-notes.pdf'} download="Supporting Notes.pdf">Supporting notes</a>

                    </Button>

                    <Button
                        type={'play-game'}
                        onClick={this.props.showGameIntro}>Start</Button>
                </div>

            </div>

        </CSSTransition>
    }
}


/**
 * map the state to props
 * @param state
 */
const mapStateToProps = state =>
{
    return {}
};


/**
 * map dispatch functions to the component props
 * @param dispatch
 * @returns {{onModeSelect: ((mode: string) => any); onCountrySelect: ((country: string) => any)}}
 */
const mapDispatchToProps = dispatch =>
{
    return {
        showLeaderboard: () => dispatch(showLeaderboard()),
        showGameIntro: () => dispatch(showGameIntro()),
        showHowToPlay: () => dispatch(showHowToPlay())
    }
};

export default screenComponent()(connect(mapStateToProps, mapDispatchToProps)(MainMenu));



// WEBPACK FOOTER //
// ./src/ts/app/screens/main-menu/MainMenu.tsx